import React, { useEffect } from "react";
import { Container } from "./styled";

function HistoryTeamSelector({
  appData,
  activeProfile,
  activeSeason,
  setActiveHistoryTeam,
  activeHistoryTeam,
}) {
  // Find all teams that match the active season
  const teamsForActiveSeason = activeProfile.teams_history
    .filter((item) => item.season === activeSeason)
    .map((item) => {
      return appData.teams.find((team) => team._id === item.teamId);
    })
    .filter((team) => team); // Filter out undefined teams

  const activeTeamHistory = activeProfile.teams_history
    .filter((item) => item.season === activeSeason)
    .sort((a, b) => {
      // Convertir fechas a objetos Date para comparar
      const dateA = new Date(a.start_date.split("/").reverse().join("-"));
      const dateB = new Date(b.start_date.split("/").reverse().join("-"));
      return dateB - dateA; // Orden descendente (más reciente primero)
    })[0];

  // Get the active team object
  const activeTeam = activeTeamHistory
    ? appData.teams.find((team) => team._id === activeTeamHistory.teamId)
    : null;

  // Determine which team to display
  const displayTeam = activeTeam || teamsForActiveSeason[0] || null;

  useEffect(() => {
    if (displayTeam !== null) setActiveHistoryTeam(displayTeam._id);
    else setActiveHistoryTeam(null);
  }, []);

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    const dropdown = document.getElementById("team-dropdown");
    if (dropdown) {
      dropdown.classList.toggle("show");
    }
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const closeDropdown = (event) => {
      if (!event.target.matches(".dropdown-button")) {
        const dropdowns = document.getElementsByClassName("dropdown-content");
        for (let i = 0; i < dropdowns.length; i++) {
          const openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      }
    };

    window.addEventListener("click", closeDropdown);
    return () => {
      window.removeEventListener("click", closeDropdown);
    };
  }, []);

  // If no team found
  if (!displayTeam) {
    return <p>No team found for the active season</p>;
  }

  // If there's only one team, show it without dropdown
  if (teamsForActiveSeason.length <= 1) {
    return <p className="team-name">{displayTeam.name}</p>;
  }
  const getDisplayName = () => {
    if (activeHistoryTeam !== null) {
      const selectedTeam = teamsForActiveSeason.find(
        (team) => team._id === activeHistoryTeam
      );
      return selectedTeam?.name || "Temporada completa";
    } else {
      return activeTeam ? activeTeam.name : displayTeam?.name || "Select Team";
    }
  };

  // If no team found
  if (!displayTeam) {
    return <p>No team found for the active season</p>;
  }

  // If there's only one team, show it without dropdown
  if (teamsForActiveSeason.length <= 1) {
    return <p className="team-name">{displayTeam.name}</p>;
  }

  return (
    <Container>
      <button onClick={toggleDropdown} className="dropdown-button">
        {getDisplayName()}
        <span className="dropdown-arrow">▼</span>
      </button>
      <div id="team-dropdown" className="dropdown-content">
        <p
          onClick={() => setActiveHistoryTeam("season")}
          className={activeHistoryTeam === "all" ? "active" : ""}
        >
          ESTA TEMPORADA
        </p>
        {teamsForActiveSeason.map((team) => (
          <p onClick={(e) => setActiveHistoryTeam(team._id)}>{team.name}</p>
        ))}
      </div>
    </Container>
  );
}

export default HistoryTeamSelector;
